<div class="log" #log (scroll)="onLogScroll()">
  @if (loadingMessages) {
    <div class="chat-loading" aria-live="polite" aria-busy="true">
      <span class="chat-loading__spinner" aria-hidden="true"></span>
    </div>
  } @else {
  @if (msgCursor !== null) {
    <button type="button" class="load-earlier" (click)="loadOlderMessages()">
      Load earlier messages
    </button>
  }

  @if (messages.length === 0) {
    <div class="welcome">
      <span class="welcome__brand" aria-hidden="true">
        <!-- Pebbl sparkle — same mark as the sidebar header and floating widget head. -->
        <svg viewBox="0 0 20 20" fill="none" width="100%" height="100%"><path d="M17.1982 1.9002V5.50011M18.9982 3.70016H15.3982M2.79858 14.4999V16.2998M3.69856 15.3999H1.8986M8.14174 13.1499C8.06139 12.8385 7.89905 12.5542 7.67161 12.3268C7.44417 12.0993 7.15993 11.937 6.84847 11.8567L1.32712 10.4329C1.23292 10.4062 1.15001 10.3494 1.09098 10.2713C1.03194 10.1932 1 10.0979 1 10C1 9.90208 1.03194 9.80683 1.09098 9.72871C1.15001 9.65058 1.23292 9.59385 1.32712 9.56711L6.84847 8.14245C7.15982 8.06217 7.44398 7.89997 7.67141 7.67269C7.89885 7.44542 8.06125 7.16137 8.14174 6.85008L9.5655 1.32872C9.59197 1.23414 9.64865 1.15083 9.72689 1.09148C9.80513 1.03213 9.90064 1 9.99884 1C10.097 1 10.1926 1.03213 10.2708 1.09148C10.349 1.15083 10.4057 1.23414 10.4322 1.32872L11.855 6.85008C11.9354 7.16153 12.0977 7.44577 12.3252 7.67321C12.5526 7.90066 12.8369 8.063 13.1483 8.14335L18.6697 9.56621C18.7646 9.5924 18.8483 9.64902 18.908 9.72737C18.9677 9.80573 19 9.90151 19 10C19 10.0985 18.9677 10.1943 18.908 10.2726C18.8483 10.351 18.7646 10.4076 18.6697 10.4338L13.1483 11.8567C12.8369 11.937 12.5526 12.0993 12.3252 12.3268C12.0977 12.5542 11.9354 12.8385 11.855 13.1499L10.4313 18.6713C10.4048 18.7659 10.3481 18.8492 10.2699 18.9085C10.1917 18.9679 10.0961 19 9.99794 19C9.89974 19 9.80423 18.9679 9.72599 18.9085C9.64775 18.8492 9.59107 18.7659 9.5646 18.6713L8.14174 13.1499Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </span>
      <h2 class="welcome__title">Hi {{ greetingName }} - how can I help?</h2>
      <p class="welcome__sub">
        Internal sales support assistant for GatherCo, helping the team answer customer
        questions about products, specifications, samples, ordering, stock, delivery, installation
        guidance, maintenance, warranties, and general enquiries with clear, accurate, and consistent
        responses.
      </p>

      <div class="welcome__suggested">
        <div class="welcome__suggested-label">Suggested</div>

        <button type="button" class="suggestion" (click)="runQuery('Can this stone be used around a pool?')">
          <span class="suggestion__icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /></svg>
          </span>
          <span class="suggestion__text">Can this stone be used around a pool?<span class="suggestion__hint">Poolside suitability, slip &amp; salt resistance</span></span>
        </button>

        <button type="button" class="suggestion" (click)="runQuery('How should I explain the difference between porcelain and natural stone?')">
          <span class="suggestion__icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>
          </span>
          <span class="suggestion__text">How should I explain the difference between porcelain and natural stone?<span class="suggestion__hint">Composition, look &amp; upkeep compared</span></span>
        </button>

        <button type="button" class="suggestion" (click)="runQuery('What should I tell a customer about sealing and maintenance?')">
          <span class="suggestion__icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="8" r="3.5" /><path d="M4 20c0-3.3 2.7-6 6-6 1 0 2 .25 2.8.7" /><circle cx="17.5" cy="16.5" r="3" /><line x1="21.5" y1="20.5" x2="19.6" y2="18.6" /></svg>
          </span>
          <span class="suggestion__text">What should I tell a customer about sealing and maintenance?<span class="suggestion__hint">Sealing, cleaning &amp; long-term care</span></span>
        </button>

        <button type="button" class="suggestion" (click)="runQuery('How do I answer a customer asking about lead time?')">
          <span class="suggestion__icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="8" r="3.5" /><path d="M4 20c0-3.3 2.7-6 6-6 1 0 2 .25 2.8.7" /><circle cx="17.5" cy="16.5" r="3" /><line x1="21.5" y1="20.5" x2="19.6" y2="18.6" /></svg>
          </span>
          <span class="suggestion__text">How do I answer a customer asking about lead time?<span class="suggestion__hint">Stock, production &amp; delivery timing</span></span>
        </button>
      </div>
    </div>
  }

  @for (m of messages; track trackByIndex($index); let i = $index) {
    @if (m.role === 'user') {
      <div class="msg user">
        <!-- Sent images sit above the prompt, outside the bubble: a lone image keeps its
             own proportions, several read as a row of square tiles. -->
        @if (m.attachments?.length) {
          <div [class]="imageGridClass(m.attachments!.length)">
            @for (img of m.attachments; track trackByImage($index, img)) {
              @if (isImageBroken(img)) {
                <div class="msg-image msg-image--broken" [title]="img.fileName">Image unavailable</div>
              } @else {
                <button
                  type="button"
                  class="msg-image"
                  [style.aspect-ratio]="thumbAspectRatio(m.attachments!.length, img)"
                  [attr.aria-label]="'Expand ' + img.fileName"
                  (click)="openLightbox(img)"
                >
                  <img
                    [src]="img.url"
                    [alt]="img.fileName"
                    loading="lazy"
                    [attr.width]="img.width || null"
                    [attr.height]="img.height || null"
                    (error)="onImageError(img)"
                  />
                </button>
              }
            }
          </div>
        }
        @if (m.text) {
          <div class="bubble">
            <span class="bubble__text">{{ m.text }}</span>
          </div>
        }
        @if (m.createdAt) {
          <div class="msg__time msg__time--user">{{ formatMsgTime(m.createdAt) }}</div>
        }
      </div>
    } @else if (hasContent(m) || m.streaming) {
      <div class="msg assistant">
        <div class="msg__head">
          <span class="msg__name"><span class="msg__name-star" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 20 20" fill="none"><path d="M17.1982 1.9002V5.50011M18.9982 3.70016H15.3982M2.79858 14.4999V16.2998M3.69856 15.3999H1.8986M8.14174 13.1499C8.06139 12.8385 7.89905 12.5542 7.67161 12.3268C7.44417 12.0993 7.15993 11.937 6.84847 11.8567L1.32712 10.4329C1.23292 10.4062 1.15001 10.3494 1.09098 10.2713C1.03194 10.1932 1 10.0979 1 10C1 9.90208 1.03194 9.80683 1.09098 9.72871C1.15001 9.65058 1.23292 9.59385 1.32712 9.56711L6.84847 8.14245C7.15982 8.06217 7.44398 7.89997 7.67141 7.67269C7.89885 7.44542 8.06125 7.16137 8.14174 6.85008L9.5655 1.32872C9.59197 1.23414 9.64865 1.15083 9.72689 1.09148C9.80513 1.03213 9.90064 1 9.99884 1C10.097 1 10.1926 1.03213 10.2708 1.09148C10.349 1.15083 10.4057 1.23414 10.4322 1.32872L11.855 6.85008C11.9354 7.16153 12.0977 7.44577 12.3252 7.67321C12.5526 7.90066 12.8369 8.063 13.1483 8.14335L18.6697 9.56621C18.7646 9.5924 18.8483 9.64902 18.908 9.72737C18.9677 9.80573 19 9.90151 19 10C19 10.0985 18.9677 10.1943 18.908 10.2726C18.8483 10.351 18.7646 10.4076 18.6697 10.4338L13.1483 11.8567C12.8369 11.937 12.5526 12.0993 12.3252 12.3268C12.0977 12.5542 11.9354 12.8385 11.855 13.1499L10.4313 18.6713C10.4048 18.7659 10.3481 18.8492 10.2699 18.9085C10.1917 18.9679 10.0961 19 9.99794 19C9.89974 19 9.80423 18.9679 9.72599 18.9085C9.64775 18.8492 9.59107 18.7659 9.5646 18.6713L8.14174 13.1499Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span> Pebbl</span>
          @if (m.createdAt) {
            <span class="msg__time">{{ formatMsgTime(m.createdAt) }}</span>
          }
        </div>
        @let parts = messageParts(m);
        @if (m.streaming && !m.text && !hasBlockComponents(m)) {
          <div class="status">{{ status || 'Thinking…' }}</div>
        }

        @if (m.text || hasBlockComponents(m) || showUnplacedCards(m, parts)) {
          <div class="bubble" [class.bubble--entries]="parts.skus.length > 0 || parts.placed > 0">
            <!-- Each paragraph or list item that opens on a bold, linked product name is an
                 entry, and takes the picture of the card whose product_link it links to.
                 Cards no entry took (linked only in a table, say) wait for the reply to
                 settle, then sit in a strip under it. -->
            @for (seg of parts.segments; track seg.key) {
              @if (seg.entry !== null) {
                <app-ai-product-entry [skus]="parts.skus" [index]="seg.card" [link]="seg.href ?? null"
                                      [name]="seg.name ?? ''" [divided]="seg.followsEntry">
                  <div class="markdown" [innerHTML]="seg.html"></div>
                </app-ai-product-entry>
              } @else if (seg.kind === 'email') {
                <div class="email-draft">
                  <div class="email-draft__head">
                    <span class="email-draft__label">Email draft</span>
                    <button
                      type="button"
                      class="email-draft__copy"
                      [class.email-draft__copy--ok]="copiedEmail === i + ':' + seg.key"
                      (click)="copyEmail(i + ':' + seg.key, seg.rawHtml)"
                    >
                      {{ copiedEmail === i + ':' + seg.key ? 'Copied' : 'Copy email' }}
                    </button>
                  </div>
                  <div class="markdown email-draft__body" [innerHTML]="seg.html" (copy)="onEmailCopy($event)"></div>
                </div>
              } @else {
                <div class="markdown" [innerHTML]="seg.html"></div>
              }
            }
            @if (m.streaming) {
              <span class="caret"></span>
            }
            @if (showUnplacedCards(m, parts)) {
              <app-ai-product-cards [skus]="parts.stripSkus"></app-ai-product-cards>
            }

            @for (c of m.components; track $index) {
              @if (asTable(c); as table) {
                <div class="table-wrap">
                  <div class="table-actions">
                    <button type="button" class="mini-btn" [class.mini-btn--ok]="copiedTable === i" (click)="copyTableCsv(i, table)">
                      {{ copiedTable === i ? 'Copied' : 'Copy CSV' }}
                    </button>
                    <button type="button" class="mini-btn" (click)="downloadTableCsv(table)">Download</button>
                  </div>
                  <div class="table-scroll">
                    <table>
                      <thead>
                        <tr>
                          @for (col of table.columns; track col) { <th>{{ col }}</th> }
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of table.rows; track $index) {
                          <tr>
                            @for (cell of row; track $index) {
                              <td>{{ cell === null || cell === undefined ? '' : cell }}</td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  @if (table.totalCount !== undefined) {
                    <div class="table-meta">{{ table.totalCount }} rows</div>
                  }
                </div>
              } @else if (c.type === 'metric') {
                <div class="metric">
                  {{ c.value }}@if (c.unit) { <span class="unit"> {{ c.unit }}</span> }
                  <small>{{ c.label }}</small>
                </div>
              }
            }

            @if (m.text && !m.streaming) {
              <div class="bubble__actions">
                @if (activeId && m.uuid) {
                  <button
                    type="button"
                    class="icon-btn"
                    [class.icon-btn--active]="m.feedback === 'up'"
                    [attr.data-tip]="m.feedback === 'up' ? 'Liked' : 'Good response'"
                    aria-label="Good response"
                    [attr.aria-pressed]="m.feedback === 'up'"
                    (click)="vote(m, 'up')"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" [attr.fill]="m.feedback === 'up' ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" /></svg>
                  </button>
                  <button
                    type="button"
                    class="icon-btn"
                    [class.icon-btn--active]="m.feedback === 'down'"
                    [attr.data-tip]="m.feedback === 'down' ? 'Disliked' : 'Bad response'"
                    aria-label="Bad response"
                    [attr.aria-pressed]="m.feedback === 'down'"
                    (click)="vote(m, 'down')"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" [attr.fill]="m.feedback === 'down' ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" /></svg>
                  </button>
                }
                @if (canRegenerate(i)) {
                  <button type="button" class="icon-btn" data-tip="Regenerate" aria-label="Regenerate response" (click)="regenerate(m)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6M1 20v-6h6" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>
                  </button>
                }
                <button type="button" class="icon-btn" [class.icon-btn--ok]="copiedAnswer === i" [attr.data-tip]="copiedAnswer === i ? 'Copied' : 'Copy response'" aria-label="Copy answer" (click)="copyAnswer(i, m.text)">
                  @if (copiedAnswer === i) {
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                  } @else {
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
                  }
                </button>
                @if (m.usage) {
                  <button type="button" class="icon-btn icon-btn--cost" [attr.data-tip]="usageTip(m.usage)" aria-label="Message cost">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 6v12M15.5 9a3.5 2.4 0 0 0-3.5-2 3 2.2 0 0 0-3 2c0 1.2 1 1.8 3 2.2s3.5 1 3.5 2.3a3 2.3 0 0 1-3.5 2 3.6 2.5 0 0 1-3.5-2" /></svg>
                  </button>
                }
              </div>
            }
          </div>
        }

        @if (m.error) {
          <div class="error-card" role="alert">
            <span class="error-card__icon" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
            </span>
            <div class="error-card__body">
              <div class="error-card__title">Something went wrong.</div>
              <div class="error-card__text">{{ m.error }}</div>
            </div>
          </div>
        }
      </div>
    }
  }

  }

  <!-- Bottom sentinel: auto-scroll target while streaming. -->
  <div #endAnchor></div>
</div>

@if (!atBottom && messages.length > 0) {
  <button type="button" class="scroll-bottom" (click)="scrollToBottom()" aria-label="Scroll to bottom" title="Scroll to bottom">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 5v14M5 12l7 7 7-7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
}

<form class="composer" (ngSubmit)="runQuery(input)">
  <div
    class="composer__box"
    [class.composer__box--dragover]="dragOver"
    (dragover)="onComposerDragOver($event)"
    (dragleave)="onComposerDragLeave()"
    (drop)="onComposerDrop($event)"
  >
    <!-- Picked images, above the prompt: thumbnail, upload progress, remove / retry. -->
    @if (attachments.length) {
      <div class="attachments" role="list" aria-label="Attached images">
        @for (item of attachments; track trackByAttachment($index, item)) {
          <div
            role="listitem"
            class="attachment"
            [class.attachment--uploading]="item.state === 'uploading'"
            [class.attachment--failed]="item.state === 'failed'"
            [title]="item.file.name + ' (' + formatFileSize(item.file.size) + ')'"
          >
            <img [src]="item.previewUrl" [alt]="item.file.name" />
            @if (item.state === 'uploading') {
              <div class="attachment__progress" aria-label="Uploading">
                <div class="attachment__progress-bar" [style.width.%]="progressPercent(item.progress)"></div>
              </div>
            }
            @if (item.state === 'failed') {
              <button
                type="button"
                class="attachment__retry"
                [title]="item.error || 'Upload failed - click to retry'"
                [attr.aria-label]="'Retry uploading ' + item.file.name"
                (click)="retryAttachment(item.localId)"
              >
                Retry
              </button>
            }
            <button
              type="button"
              class="attachment__remove"
              [attr.aria-label]="'Remove ' + item.file.name"
              title="Remove"
              (click)="removeAttachment(item.localId)"
            >
              ×
            </button>
          </div>
        }
      </div>
    }
    @if (attachError) {
      <div class="composer__error" role="alert">{{ attachError }}</div>
    }

    <textarea
      #composerInput
      rows="1"
      [(ngModel)]="input"
      [ngModelOptions]="{ standalone: true }"
      placeholder="Ask Pebbl about products, quotes, customers…"
      (keydown.enter)="onEnter($event)"
      (paste)="onComposerPaste($event)"
      (input)="autoGrow(composerInput)"
    ></textarea>

    <div class="composer__bar">
      <div class="composer__selects">
        <!-- Attach images to the prompt. Opens the OS file picker via the hidden input;
             the files upload straight to S3 and are sent with the next turn. -->
        <input
          #fileInput
          type="file"
          class="composer__file-input"
          multiple
          [accept]="attachmentAccept"
          (change)="onFilesSelected($event)"
        />
        <button
          type="button"
          class="composer__attach"
          [disabled]="attachments.length >= maxAttachments"
          (click)="fileInput.click()"
          aria-label="Attach images"
          [title]="attachments.length >= maxAttachments ? 'Up to ' + maxAttachments + ' images' : 'Attach images'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
          </svg>
        </button>
        <!-- Model picker — console-v2's app-model-select markup verbatim: a bordered
             trigger over an upward-opening menu whose rows pair the model name with
             the usage hint the API sends. -->
        <div class="model-select" #modelSelect>
          <button
            type="button"
            class="model"
            (click)="toggleModelOpen()"
            title="Choose model"
            [attr.aria-expanded]="modelOpen"
          >
            {{ selectedModelLabel }} <span class="model-caret">▼</span>
          </button>

          @if (modelOpen) {
            <div class="menu">
              @for (model of models; track model.value) {
                <button
                  type="button"
                  class="opt"
                  [class.sel]="model.value === selectedModel"
                  (click)="selectModel(model)"
                >
                  <span class="name">{{ model.label }}</span>
                  @if (model.description) {
                    <span class="hint">({{ model.description }})</span>
                  }
                </button>
              }
            </div>
          }
        </div>
        <!-- Thinking-level picker — same markup as the model picker. Built from the selected
             model's own level list, so a model with fewer levels needs no change here.
             The "Thinking" prefix and the menu heading say what the levels measure. -->
        <div class="model-select" #thinkingSelect>
          <button
            type="button"
            class="model"
            (click)="toggleThinkingOpen()"
            title="Choose thinking effort"
            [attr.aria-expanded]="thinkingOpen"
          >
            <span class="model-kind">Thinking</span> {{ selectedThinkingLabel }} <span class="model-caret">▼</span>
          </button>

          @if (thinkingOpen) {
            <div class="menu">
              <div class="menu-head">
                <span class="menu-title">Thinking effort</span>
                <span class="menu-sub">How much Pebbl reasons before it replies</span>
              </div>
              @for (level of thinkingLevels; track level.value) {
                <button
                  type="button"
                  class="opt"
                  [class.sel]="level.value === selectedThinkingLevel"
                  (click)="selectThinkingLevel(level)"
                >
                  <span class="name">{{ level.label }}</span>
                  @if (level.description) {
                    <span class="hint">({{ level.description }})</span>
                  }
                </button>
              }
            </div>
          }
        </div>
      </div>

      @if (viewingStream) {
        <button type="button" class="composer__send composer__send--stop" (click)="stop()" aria-label="Stop" title="Stop">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="5" y="5" width="14" height="14" rx="2.5" /></svg>
        </button>
      } @else {
        <button
          type="submit"
          class="composer__send"
          [disabled]="sendDisabled"
          aria-label="Send"
          [title]="streaming ? 'Waiting for the current reply…' : uploadInFlight ? 'Waiting for the upload to finish…' : 'Send'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </button>
      }
    </div>
  </div>
  <p class="composer__disclaimer">Pebbl can make mistakes - verify stock, pricing and freight before sending to customers.</p>
</form>

@if (feedbackTarget) {
  <app-chat-feedback-popup
    (submitted)="onFeedbackSubmit($event)"
    (cancelled)="onFeedbackCancel()"
  ></app-chat-feedback-popup>
}

<!-- Full-size overlay for one sent image; dismissed by backdrop click or Escape. -->
@if (lightbox) {
  <div class="lightbox" role="dialog" aria-modal="true" (click)="closeLightbox()">
    <img [src]="lightbox.url" [alt]="lightbox.fileName" (click)="$event.stopPropagation()" />
    <button type="button" class="lightbox__close" aria-label="Close image" (click)="closeLightbox()">×</button>
  </div>
}
